import type { ValueOf } from 'cpool-utils';

export const COLORS = {
    BLUE: 'blue',
    GREEN: 'green',
    GREY: 'grey',
    RED: 'red',
    WHITE: 'white',
    YELLOW: 'yellow',
} as const;

export type COLOR = ValueOf<typeof COLORS>;
